import { createSlice } from "@reduxjs/toolkit";
import official1 from "assets/images/official-1.png";
import official2 from "assets/images/official-2.png";
import official3 from "assets/images/official-3.png";
import official4 from "assets/images/official-4.png";

const initialState = {
  data: [
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
    {
      name: "Carter Stanton",
      title: "Scorer",
      img: official1,
    },
    {
      name: "Cristofer Geidt",
      title: "Umpire",
      img: official2,
    },
    {
      name: "James Workman",
      title: "Umpire",
      img: official3,
    },
    {
      name: "Zain Levin",
      title: "Umpire",
      img: official4,
    },
  ],
};

export const Officials = createSlice({
  name: "relatedMatchData",
  initialState,
});

export default Officials.reducer;
